import { mapState } from 'vuex';

import { baseFilters } from '@/utils/baseFilters';
import { notificationsMixin } from './notifications';
import { modalMixin } from './modal';

/**
 * Mixin listy encji
 * Zawiera pola:
 *  - `list` - lista encji
 *  - `count` - liczba encji
 *  - `idToDelete` - identyfikator obiektu do usunięcia
 * Zawiera metody:
 *  - `showDeleteDialog(id)` - wyświetla potwierdzenie usunięcia
 *  - `hideDeleteDialog()` - ukrywa potwierdzenie usunięcia
 *  - `remove(id)` - usuwa encję
 *  - `reloadList(pagination)` - przeładowuje listę
 * Pobiera listę encji przed załadowaniem komponentu
 *
 * @export
 * @param {*} moduleName - nazwa modułu store
 * @param {Object} messages - obiekt z wiadomościami do wyświetlenia po wykonaniu akcji i w przypadku niepowodzenia
 * @param {string} messages.added - wiadomość po dodaniu encji
 * @param {string} messages.addError - wiadomość w przypadku niepowodzenia przy dodawaniu encji
 * @param {string} messages.updated - wiadomość po aktualizacji encji
 * @param {string} messages.updateError - wiadomość w przypadku niepowodzenia przy aktualizacji encji
 * @param {string} messages.deleted - wiadomość po usunięciu encji
 * @param {string} messages.deleteError - wiadomość w przypadku niepowodzenia przy usuwaniu encji
 * @param {string} messages.listError - wiadomość w przypadku niepowodzenia przy pobieraniu listy
 * @param {string} messages.getError - wiadomość w przypadku niepowodzenia przy pobieraniu encji
 * @returns {Object} mixin
 */
export function listMixin(moduleName, messages) {
  return {
    mixins: [notificationsMixin, modalMixin(moduleName, messages)],
    /**
     * Dane modułu
     *
     * @returns
     */
    data() {
      return {
        moduleName,
        idToDelete: undefined
      };
    },
    methods: {
      /**
       * Otwiera okienko z potwierdzeniem usunięcia
       *
       * @param {*} id
       */
      showDeleteDialog(id) {
        this.idToDelete = id;
      },
      /**
       * Ukrywa okienko z potwierdzeniem usunięcia
       */
      hideDeleteDialog() {
        this.idToDelete = undefined;
      },
      /**
       * Usuwa encję
       *
       * @param {*} id
       */
      remove(id) {
        this.$store
          .dispatch(`${moduleName}/remove`, id)
          .then(() => this.notifySuccess(messages.deleted))
          .catch(err => this.notifyError(messages.deleteError));
      },

      /**
       * Przeładowuje listę
       *
       * @param {*} pagination
       */
      reloadList(route) {
        return this.$store
          .dispatch(`${moduleName}/list`, this.filters(baseFilters(route), route))
          .catch(err => this.notifyError(messages.listError));
      },

      // @vuese
      // Tworzy filtr na podstawie paginacji
      filters(pagination, route) {
        if (!pagination.order) {
          delete pagination.order;
        }
        return pagination;
      }
    },
    computed: {
      ...mapState({
        list: state => state[moduleName].list,
        count: state => state[moduleName].count
      }),

      csvFilters() {
        const filters = this.filters(baseFilters(this.$route), this.$route);
        return Object.keys(filters)
          .filter(key => !['count', 'start'].includes(key))
          .map(key => ({
            name: key,
            value: typeof filters[key] === 'object' ? JSON.stringify(filters[key]) : filters[key]
          }));
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.reloadList(to)
        .then(() => next())
        .catch(err => this.notifyError(errors.listError));
    }
  };
}
